import type { SVGProps } from 'react';

/**
 * Derivation — Funnel / Aggregation.
 *
 * Symbolisiert das Konzept "mehrere Eingangs-Datensaetze, ein abgeleiteter
 * Ergebnis-Dataset". Im Lucide-Stil gehalten.
 */
export function DerivationIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path d="M3 5 H21 L14 13 V20 L10 18 V13 Z" />
      <line x1="7" y1="9" x2="17" y2="9" />
    </svg>
  );
}
